import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ConstantsUtils} from '../../../utils/constants.utils';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-countries-filter',
    templateUrl: './countries-filter.component.html',
    styleUrls: ['./countries-filter.component.scss']
})
export class CountriesFilterComponent implements OnInit, OnDestroy {
    // myControl = new FormControl();
    // filteredCountries: Observable<any>;

    @Input() appendTo;
    countries = ConstantsUtils.countries;
    selectedCountry;

    unsubscribe$ = new Subject();

    constructor(private route: ActivatedRoute, private router: Router) {}

    ngOnInit() {
        this.route.queryParamMap
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(params => {
                const country = params.get('country');
                this.selectedCountry = this.countries.find(c => c.value === country);
            });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    async countryChange(country) {
        await this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
                country: (country || {}).value,
                countryCode: (country || {}).code
            },
            queryParamsHandling: 'merge'
        });
    }
}
